import { render, staticRenderFns } from "./PhotoCapture.vue?vue&type=template&id=337ab81a&scoped=true&"
import script from "./PhotoCapture.vue?vue&type=script&lang=ts&"
export * from "./PhotoCapture.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoCapture.vue?vue&type=style&index=0&id=337ab81a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337ab81a",
  null
  
)

export default component.exports